import { useContext, useEffect, useState } from "react";
import FormSubmissionsList from "./FormSubmissionsList/FormSubmissionsList";
import { DependencyInjectionContext } from "../../../contexts/dependency-injection-context";
import { FormSubmission, FormSubmissionsListResponse } from "../../../common";
import { ClientSelector } from "../../../components/core/ClientSelector/ClientSelector";
import { LoadingIndicator } from "../../../components/core/LoadingIndicator/LoadingIndicator";
import { MsalAuthenticationTemplate, useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "../../../authConfig";

const FormSubmissions = () => {

  const [submissions, setSubmissions] = useState<FormSubmission[]>();
  const [loading, setLoading] = useState<boolean>(false);
  const { formsApi, applicationState } = useContext(DependencyInjectionContext);
  const [selectedClientId, setSelectedClientId] = useState<string>();

  const authRequest = {
    ...loginRequest
  };

  const {login, result, error} = useMsalAuthentication(InteractionType.Redirect);

  const getFormSubmissions = async (clientId: string | null = null) => {
    setLoading(true);

    let url = `FormSubmissionsGet?`;
    if (clientId != null) {
      url = `${url}clientId=${clientId}`;
    }

    const response = await formsApi.get<FormSubmissionsListResponse>(url);
    setSubmissions(response.submissions);

    setLoading(false);
  }

  const onClientSelected = async (clientId: string) => {
    setSelectedClientId(clientId);
    applicationState.selectedClientId = clientId;
    getFormSubmissions(clientId);
  };

  return (
    <div className="page">
      <div style={{ marginTop: '20px' }}>
        <ClientSelector onClientSelected={onClientSelected}></ClientSelector>
      </div>
      <FormSubmissionsList submissions={submissions} clientId={selectedClientId}></FormSubmissionsList>
      <LoadingIndicator loading={loading}></LoadingIndicator>
    </div>
  );

};

export default FormSubmissions;